import React from "react";
import "./Pagination.css";

function Pagination({ pagedata, onPageChange }) {
  const currentPage = Number(pagedata?.currentPage || pagedata?.page || 1);
  const pageSize = Number(pagedata?.pageSize || pagedata?.limit || 10);
  const totalCount = Number(pagedata?.totalCount ?? pagedata?.total ?? 0);
  const totalPages = Math.max(
    1,
    Number(pagedata?.totalPages || Math.ceil(totalCount / pageSize) || 1),
  );

  // Calculate the range of page numbers to display
  const getPageNumbers = () => {
    const delta = 2; // number of pages to show on each side of current
    const range = [];
    const rangeWithDots = [];
    let l;

    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        (i >= currentPage - delta && i <= currentPage + delta)
      ) {
        range.push(i);
      }
    }

    range.forEach((i) => {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push("...");
        }
      }
      rangeWithDots.push(i);
      l = i;
    });

    return rangeWithDots;
  };

  const pageNumbers = getPageNumbers();

  const getPageRangeText = () => {
    const startRange = (currentPage - 1) * pageSize + 1;
    const endRange = Math.min(currentPage * pageSize, totalCount);
    if (totalCount === 0) return "0 of 0";
    return `${startRange}-${endRange} of ${totalCount}`;
  };

  return (
    <div className="pagination">
      <p className="pagination-info">Showing {getPageRangeText()}</p>
      <div className="paginationbtns">
        <button
          disabled={currentPage === 1}
          className="pagination_button pagination_first"
          onClick={() => onPageChange(1)}
          aria-label="First page"
        >
          <span className="icon">⟪</span>
        </button>
        <button
          disabled={currentPage === 1}
          className="pagination_button"
          onClick={() => onPageChange(currentPage - 1)}
        >
          Previous
        </button>

        {pageNumbers.map((page, index) =>
          page === "..." ? (
            <span key={`ellipsis-${index}`} className="pagination_ellipsis">
              …
            </span>
          ) : (
            <button
              key={page}
              className={
                page === currentPage
                  ? "pagination_activebutton"
                  : "pagination_button"
              }
              onClick={() => onPageChange(page)}
              aria-current={page === currentPage ? "page" : undefined}
            >
              {page}
            </button>
          ),
        )}

        <button
          disabled={currentPage === totalPages}
          className="pagination_button"
          onClick={() => onPageChange(currentPage + 1)}
        >
          Next
        </button>
        <button
          disabled={currentPage === totalPages}
          className="pagination_button pagination_last"
          onClick={() => onPageChange(totalPages)}
          aria-label="Last page"
        >
          <span className="icon">⟫</span>
        </button>
      </div>
    </div>
  );
}

export default Pagination;
